const filters = () => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('items', []);
      Alpine.store('upsellOptions', []);
      Alpine.store('totalPrice', 0);
      Alpine.store('totalItems', 0);
  
      Alpine.data('filters', () => ({
        open: false,
        loading: true,
        addingUpsell: false,
        items: [],
        upsellOptions: [],
        totalPrice: 0,
        totalItems: 0,
        overlayOpen(e) {
          if (e.detail.overlay !== 'filters') {
            this.closeFilters();
          }
        },
        init() {
          this.getFilters();
        },
        closeFilters() {
          this.open = false;
          this.$dispatch('overlay:close', { overlay: 'filters' });
        },
        toggleFilters() {
          this.open = !this.open;
  
          if (this.open) {
            this.$dispatch('overlay:open', { overlay: 'filters' });
          } else {
            this.$dispatch('overlay:close', { overlay: 'filters' });
          }
        },
        getItemFromVariant(variantId) {
          return this.$store.items.find((item) => variantId.includes(item.variant_id));
        },
        getFilters() {
          this.loading = true;
  
          fetch(`${window.Shopify.routes.root}filters.js`)
            .then((res) => res.json())
            .then((res) => {
              console.log(res);
              this.$store.items = res.items;
              this.$store.totalPrice = res.items_subtotal_price;
              this.$store.totalItems = res.item_count;
  
              this.$dispatch('filters:updated', {
                items: res.items,
                totalPrice: res.items_subtotal_price,
                totalItems: res.item_count,
              });
  
              this.getUpsellOptions();
            })
            .catch((err) => {})
            .finally(() => {
              this.loading = false;
            });
        },
        makeid(length) {
          let result = '';
          const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
          const charactersLength = characters.length;
          let counter = 0;
          while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
          }
          return result;
        },
        getUpsellOptions() {
          const variantOptions = this.$store.items.map((item) => item.options_with_values);
  
          let query = '';
  
          const metafieldQuery = `
            metafield(key: "upsell_option", namespace: "custom") {
              value
            }
          `;
  
          if (this.$store.items.length === 0) {
            this.$store.upsellOptions = [];
            return;
          }
  
          query = 'query {';
          this.$store.items.forEach((item) => {
            if (item.options_with_values.length === 0) {
              return;
            }
  
            query += `
              ${this.makeid(10)}: productByHandle(handle: "${item.handle}") {
                variantBySelectedOptions(selectedOptions: {name: "${item.options_with_values[0].name}", value: "${
              item.options_with_values[0].value
            }"}) {
                  ${metafieldQuery}
                  id
                  image {
                    url(transform: {maxHeight: 200, maxWidth: 200})
                  }
                  sellingPlanAllocations(first: 10) {
                    nodes {
                      sellingPlan {
                        name
                        options {
                          name
                          value
                        }
                        id
                      }
                    }
                  }
                }
              }
            `;
          });
          query += '}';
  
          const variantIds = [];
          const variantImgs = [];
  
          this.graphqlQuery(query)
            .then((d) => {
              query = '{';
  
              Object.keys(d.data).forEach((key) => {
                if (!d.data[key].variantBySelectedOptions.metafield) {
                  return;
                }
  
                variantIds.push(d.data[key].variantBySelectedOptions.id);
                variantImgs.push(d.data[key].variantBySelectedOptions.image.url);
  
                const { value } = d.data[key].variantBySelectedOptions.metafield;
  
                query += `
                ${this.makeid(10)}: metaobject(id: "${value}") {
                  fields {
                    key
                    value
                    reference {
                      ... on ProductVariant {
                        image {
                          url(transform: {maxHeight: 200, maxWidth: 200})
                        }
                      }
                    }
                  }
                }
              `;
              });
  
              query += '}';
  
              return this.graphqlQuery(query);
            })
            .then((d) => {
              if (d.data) {
                const upsellOptions = [];
  
                Object.keys(d.data).forEach((key, index) => {
                  const { fields } = d.data[key];
  
                  // check if fields has a product_variant key
                  // if it does, then we need to get the variant id from the product
                  // and check if it's already in the filters or not
                  // if it is, then we need to remove it from the upsell options
                  // if it's not, then we need to add it to the upsell options
  
                  fields.forEach((field) => {
                    if (field.key === 'product_variant') {
                      const variantId = field.value;
  
                      const variantInFilters = this.$store.items.find((item) => variantId.includes(item.variant_id));
  
                      if (variantInFilters) {
                        console.log('infilters');
                      } else {
                        const upsellOption = {
                          variantId: variantIds[index],
                          image: field.reference?.image?.url,
                          fields,
                        };
                        upsellOptions.push(upsellOption);
                      }
                    }
                  });
                });
  
                // need to make sure we don't add the same upsell option twice
  
                const uniqueUpsellOptions = [];
  
                upsellOptions.forEach((upsellOption) => {
                  const variantId = upsellOption.variantId;
  
                  const variantInUpsellOptions = uniqueUpsellOptions.find((item) => variantId.includes(item.variantId));
  
                  if (!variantInUpsellOptions) {
                    uniqueUpsellOptions.push(upsellOption);
                  }
                });
  
                this.$store.upsellOptions = uniqueUpsellOptions;
  
                console.log(this.$store.upsellOptions);
              }
            });
        },
        graphqlQuery: async (query) => {
          const res = await fetch(`${window.Shopify.routes.root}api/2023-10/graphql.json`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/graphql',
              'X-Shopify-Storefront-Access-Token': 'a9321fbc7c0de6615ce8603cc040a1f5',
            },
            body: query,
          });
  
          const data = await res.json();
  
          return data;
        },
        upsellClicked() {
          this.addingUpsell = true;
          const { variant, upsellVariant, upsellType } = this.$el.dataset;
  
          const uVA = upsellVariant.split('/');
          const vA = variant.split('/');
  
          const variantItem = this.getItemFromVariant(variant);
  
          if (upsellType === 'Same Product') {
            // remove existing item from filters
            this.removeItem(vA[vA.length - 1])
              .then(() => {
                // add upsell variant to filters
  
                const lineItem = {
                  id: uVA[uVA.length - 1],
                  quantity: 1,
                };
  
                if (variantItem.selling_plan_allocation?.selling_plan?.id) {
                  lineItem.selling_plan = variantItem.selling_plan_allocation.selling_plan.id;
                }
  
                return this.addItem(lineItem);
              })
              .then(() => {
                this.getUpsellOptions();
              })
              .then(() => {
                this.addingUpsell = false;
              });
          }
  
          if (upsellType === 'Additional Product') {
            // update existing variant line item properties with upsell variant id
            // so we can remove the upsell item from the filters if the user removes the original item
  
            const data = {
              id: this.getItemFromVariant(variant).key,
              properties: {
                upsell_variant: uVA[uVA.length - 1],
              },
            };
  
            this.changeItem(data)
              .then((res) => {
                this.$store.items = res.items;
                this.$store.totalPrice = res.items_subtotal_price;
                this.$store.totalItems = res.item_count;
  
                this.$dispatch('filters:updated', {
                  items: res.items,
                  totalPrice: res.items_subtotal_price,
                  totalItems: res.item_count,
                });
  
                const lineItem = {
                  id: uVA[uVA.length - 1],
                  quantity: 1,
                };
  
                if (variantItem.selling_plan_allocation?.selling_plan?.id) {
                  lineItem.selling_plan = variantItem.selling_plan_allocation.selling_plan.id;
                }
  
                return this.addItem(lineItem);
              })
              .then(this.getUpsellOptions())
              .then(() => {
                this.addingUpsell = false;
              })
              .catch((err) => {
                this.error = err;
              });
          }
        },
        changeItem(data) {
          this.loading = true;
          return fetch(`${window.Shopify.routes.root}filters/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
            .then((res) => res.json())
            .then((res) => {
              if (res.status && res.status !== 200) {
                throw new Error(res.description);
              }
  
              return res;
            })
            .catch((err) => {
              this.error = err;
            })
            .finally((res) => {
              this.loading = false;
            });
        },
        addItem(data) {
          this.loading = true;
  
          const lineItems = [];
  
          const lineItem = data;
  
          lineItems.push(lineItem);
  
          return fetch(`${window.Shopify.routes.root}filters/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: lineItems }),
          })
            .then((res) => res.json())
            .then((res) => {
              this.getFilters();
  
              return res;
            })
            .catch((err) => {})
            .finally(() => {
              this.loading = false;
            });
        },
        removeItem(variantId) {
          this.loading = true;
  
          const updates = {
            updates: {
              [variantId]: 0,
            },
          };
  
          return fetch(`${window.Shopify.routes.root}filters/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(updates),
          })
            .then((res) => res.json())
            .then((res) => {
              this.$store.items = res.items;
              this.$store.totalPrice = res.items_subtotal_price;
              this.$store.totalItems = res.item_count;
  
              this.$dispatch('filters:updated', {
                items: res.items,
                totalPrice: res.items_subtotal_price,
                totalItems: res.item_count,
              });
  
              return res;
            })
            .catch((err) => {})
            .finally(() => {
              this.loading = false;
            });
        },
        remove() {
          this.loading = true;
  
          const variantId = this.$el.dataset.variant;
          const upsellVariant = this.$el.dataset.upsellVariant;
  
          const updates = {
            updates: {
              [variantId]: 0,
            },
          };
  
          if (upsellVariant) {
            updates.updates[upsellVariant] = 0;
          }
  
          fetch(`${window.Shopify.routes.root}filters/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(updates),
          })
            .then((res) => res.json())
            .then((res) => {
              this.$store.items = res.items;
              this.$store.totalPrice = res.items_subtotal_price;
              this.$store.totalItems = res.item_count;
  
              this.$dispatch('filters:updated', {
                items: res.items,
                totalPrice: res.items_subtotal_price,
                totalItems: res.item_count,
              });
  
              this.getUpsellOptions();
            })
            .catch((err) => {})
            .finally(() => {
              this.loading = false;
            });
        },
      }));
    });
  };
  
  export default filters;
  